module.exports = __webpack_public_path__ + "static/media/IMG-2.e08f89b4.jpg";